import styled from 'styled-components';

export const ContentContainer = styled.div`
  padding: 0 2.4rem 2.4rem;
  max-width: 47.6rem;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const InfoIcon = styled.img`
  width: 8rem;
  height: 8rem;
  margin-bottom: 2rem;
`;

export const DescriptionWrapper = styled.div`
  overflow: scroll;
  white-space: pre-wrap;
  max-height: calc(100vh - 30rem);

  ${({ theme }) => theme.media.laptop`
  
  max-height: 30rem;
  `}
`;
